module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _c('br'), _c('vbl-popover', {
    attrs: {
      "place": "top"
    }
  }, [_c('vbl-button', [_vm._v("鼠标滑过显示(上)")]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("这个是一个说明！")])])], 1), _c('br'), _c('br'), _c('vbl-popover', {
    attrs: {
      "place": "bottom"
    }
  }, [_c('vbl-button', [_vm._v("鼠标滑过显示(下)")]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("这个是一个说明！")])])], 1), _c('br'), _c('br'), _c('vbl-popover', {
    attrs: {
      "place": "left"
    }
  }, [_c('vbl-button', [_vm._v("鼠标滑过显示(左)")]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("这个是一个说明！")])])], 1), _c('br'), _c('br'), _c('vbl-popover', {
    attrs: {
      "place": "right"
    }
  }, [_c('vbl-button', [_vm._v("鼠标滑过显示(右)")]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("这个是一个说明！")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67e63236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblPopover/example/vblPopoverExample.vue
// module id = 274
// module chunks = 0